import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import logBehaviorMixin from 'next/javascripts/mixins/log-behavior-mixin';
import 'next/stylesheets/components/account-setup';
import 'next/stylesheets/components/browser-preview';
import 'next/stylesheets/components/project-preview';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

Component('tr-account-setup', {
  properties: {
    projectName: String,
    step: String,
    firstTodoName: String,
    secondTodoName: String,
    thirdTodoName: String,
    firstListName: String,
    secondListName: String,
    thirdListName: String,
    projectView: String,
    defaultProjectName: String,
    defaultFirstTodoName: String,
    defaultSecondTodoName: String,
    defaultThirdTodoName: String,
    defaultFirstListName: String,
    defaultSecondListName: String,
    defaultThirdListName: String,
    animojiAvatars: Array,
    firstTodoStartAndDueAt: Array,
    secondTodoStartAndDueAt: Array,
    thirdTodoStartAndDueAt: Array,
  },

  mixins: [eventListenerMixin, logBehaviorMixin],

  connected() {
    this.initTextFields();
    this.initProjectViews();
    this.initAnimojiAvatars();
    this.initTodoStartAndDueAt();
    this.listenStepEvents();
    this.querySelectorAll('.mdc-text-field__icon').forEach((icon) => {
      icon.removeAttribute('tabindex');
    });
  },

  ready() {
    this.textFieldProjectName.textField.focus();
    this.initInfoTippy();
  },

  disconnected() {
    this.stopListening();
  },

  initInfoTippy() {
    tippy('.browser-preview', {
      content: '这是你项目的预览',
      placement: 'top-start',
      trigger: 'click',
    });
  },

  initTextFields() {
    this.textFieldProjectName = this.querySelector('.text-field-project-name');
    this.textFieldTodos = this.querySelectorAll('.text-field-todo-name');
    this.textFieldLists = this.querySelectorAll('.text-field-todolist-name');
  },

  listenStepEvents() {
    this.querySelectorAll('[data-action="next-step"]').forEach((nextStep) => {
      this.listenTo(nextStep, 'click', this.onNextStepClick.bind(this));
    });
    this.querySelectorAll('[data-action="prev-step"]').forEach((prevStep) => {
      this.listenTo(prevStep, 'click', this.onPrevStepClick.bind(this));
    });
    this.listenTo(this.textFieldProjectName, 'keyup', this.onProjectNameChanged.bind(this));
    this.textFieldTodos.forEach((textField) => {
      this.listenTo(textField, 'keyup', this.onTodoNameKeyUp.bind(this));
      this.listenTo(textField, 'change', this.onTodoNameChanged.bind(this));
    });
    this.textFieldLists.forEach((textField) => {
      this.listenTo(textField, 'keyup', this.onListNameKeyUp.bind(this));
    });
    this.querySelectorAll('input[name="select-project-view"]').forEach((radioBtn) => {
      this.listenTo(radioBtn, 'change', this.onSelectProjectView.bind(this));
    });
    this.listenTo(this, 'keydown', this.globalOnKeyDown);
    this.listenTo(this.querySelector('[data-action="finish-account-setup"'), 'click', this.beforeFinishAccountSetup.bind(this));
  },

  initProjectViews() {
    this.listView = this.querySelector('tr-list-project-preview-grid');
    this.kanbanView = this.querySelector('tr-board-project-preview-board');
    this.timelineView = this.querySelector('tr-timeline-project-preview-timeline');
    this.calendarView = this.querySelector('tr-calendar-project-preview-calendar');
    this.projectView = 'list';
  },

  initAnimojiAvatars() {
    const shuffleArray = arr => arr
      .map(a => [Math.random(), a])
      .sort((a, b) => a[0] - b[0])
      .map(a => a[1]);
    this.animojiAvatars = shuffleArray(['eva', 'noora', 'sana', 'vilde', 'tutu']);
    [this.listView, this.kanbanView, this.calendarView].forEach((view) => {
      const projectView = view;
      projectView.animojiAvatars = this.animojiAvatars;
    });
  },

  initTodoStartAndDueAt() {
    [this.listView, this.kanbanView].forEach((view) => {
      const projectView = view;
      projectView.firstTodoStartAndDueAt = this.firstTodoStartAndDueAt;
      projectView.secondTodoStartAndDueAt = this.secondTodoStartAndDueAt;
      projectView.thirdTodoStartAndDueAt = this.thirdTodoStartAndDueAt;
    });
  },

  globalOnKeyDown(e) {
    if (e.code === 'Enter' && !window.tower.metaKey(e)) {
      e.preventDefault();
      e.stopPropagation();
      const action = this.querySelector('tr-account-setup-step[active] [data-action="next-step"]');
      if (action) action.click();
    }
  },

  onNextStepClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const step = e.currentTarget.dataset.nextStep;
    this.beforeGoToStep(step);
    this.goToStep(step);
    this.afterGoToStep(step);
  },

  onPrevStepClick(e) {
    const step = e.currentTarget.dataset.prevStep;
    e.preventDefault();
    e.stopPropagation();
    this.beforeBackToStep(step);
    this.goToStep(step);
    this.afterBackToStep(step);
  },

  goToStep(step) {
    const activeStepNode = this.querySelector(`tr-account-setup-step[step="${step}"]`);
    this.querySelectorAll('tr-account-setup-step').forEach((element) => {
      const stepNode = element;
      if (stepNode === activeStepNode) {
        stepNode.setAttribute('active', true);
      } else {
        stepNode.removeAttribute('active');
      }
    });
    this.step = step;
  },

  beforeBackToStep(step) {
    switch (step) {
      case 'create-project':
        this.sendLogBehavior({ behaviorAction: 'back', ...this.stepCreateTodosLogParams() });
        break;
      case 'create-todos':
        this.sendLogBehavior({ behaviorAction: 'back', ...this.stepCreateListsLogParams() });
        break;
      case 'create-lists':
        this.sendLogBehavior({ behaviorAction: 'back', ...this.stepSelectProjectViewLogParams() });
        break;
      case 'select-project-view':
        break;
      default:
        break;
    }
  },

  afterBackToStep(step) {
    switch (step) {
      case 'create-project':
        break;
      case 'create-todos':
        break;
      case 'create-lists':
        this.querySelector('.browser-preview-positioner').style = 'transform: translateX(0px) scale(1.2);';
        break;
      case 'select-project-view':
        this.querySelector('.browser-preview-positioner').style = 'transform: translateX(0px) scale(1.0);';
        break;
      default:
        break;
    }
  },

  beforeGoToStep(step) {
    switch (step) {
      case 'create-todos':
        this.fillDefaultProjectName();
        this.sendLogBehavior({ behaviorAction: 'next', ...this.stepCreateProjectLogParams() });
        break;
      case 'create-lists':
        this.fillDefaultTodos();
        this.sendLogBehavior({ behaviorAction: 'next', ...this.stepCreateTodosLogParams() });
        break;
      case 'select-project-view':
        this.fillDefaultLists();
        this.sendLogBehavior({ behaviorAction: 'next', ...this.stepCreateListsLogParams() });
        break;
      default:
        break;
    }
  },

  afterGoToStep(step) {
    switch (step) {
      case 'create-todos':
        this.fillStepCreateTodoTitle();
        this.textFieldTodos[0].textField.focus();
        break;
      case 'create-lists':
        this.fillDefaultLists();
        this.textFieldLists[0].textField.focus();
        this.querySelector('.browser-preview-positioner').style = 'transform: translateX(0px) scale(1.2);';
        break;
      case 'select-project-view':
        this.querySelector('.browser-preview-positioner').style = 'transform: translateX(0px) scale(1.0);';
        break;
      default:
        break;
    }
  },

  beforeFinishAccountSetup() {
    this.sendLogBehavior({ behaviorAction: 'next', ...this.stepSelectProjectViewLogParams() });
  },

  basicLogParams() {
    return { resourceType: 'OnboardingGuide' };
  },

  stepCreateProjectLogParams() {
    return {
      ...this.basicLogParams(),
      ...{
        resourceId: 2,
        extraValues: {
          stage: 'setup_project_name',
          project_name: this.projectName,
          modified: this.projectName !== this.defaultProjectName,
        },
      },
    };
  },

  stepCreateTodosLogParams() {
    return {
      ...this.basicLogParams(),
      ...{
        resourceId: 3,
        extraValues: {
          stage: 'setup_todos',
          todos: [this.firstTodoName, this.secondTodoName, this.thirdTodoName],
          modified: this.firstTodoName !== this.defaultFirstTodoName
            || this.secondTodoName !== this.defaultSecondTodoName
            || this.thirdTodoName !== this.defaultThirdTodoName,
        },
      },
    };
  },

  stepCreateListsLogParams() {
    return {
      ...this.basicLogParams(),
      ...{
        resourceId: 4,
        behaviorAction: 'next',
        extraValues: {
          stage: 'setup_todolists',
          todolists: [this.firstListName, this.secondListName, this.thirdListName],
          modified: this.firstListName !== this.defaultFirstListName
            || this.secondListName !== this.defaultSecondListName
            || this.thirdListName !== this.defaultThirdListName,
        },
      },
    };
  },

  stepSelectProjectViewLogParams() {
    return {
      ...this.basicLogParams(),
      ...{
        resourceId: 5,
        extraValues: {
          stage: 'setup_project_view',
          project_view: this.projectView,
        },
      },
    };
  },

  onProjectNameChanged(e) {
    this.updateProjectName(e.target.value);
  },

  updateProjectName(projectName) {
    const { dataset: { namePlaceholder } } = this.querySelector('.project-preview-header');
    const nameElement = this.querySelector('.project-preview-header-title')
      || this.querySelector('.project-preview-header-title-placeholder');
    if (projectName && projectName.length > 0) {
      nameElement.outerHTML = `<div class="project-preview-header-title">${projectName}</div>`;
    } else {
      nameElement.outerHTML = `<div class="project-preview-header-title-placeholder">${namePlaceholder}</div>`;
    }
    this.projectName = projectName;
    this.syncSetupParams();
  },

  onTodoNameKeyUp(e) {
    const { target: { value: todoName }, currentTarget: { dataset: { targetTodo } } } = e;
    this.updateTodoName(targetTodo, todoName);
  },

  onTodoNameChanged(e) {
    const { target: { value: todoName }, currentTarget: { dataset: { targetTodo } } } = e;
    this.updateTodoName(targetTodo, todoName, { create: true });
  },

  updateTodoName(todo, name, { create = false } = {}) {
    const targetTodoName = `${todo}Name`;
    this[targetTodoName] = name;
    if (this.listView) this.listView.updateTodoName(todo, name, { create });
    if (this.kanbanView) this.kanbanView.updateTodoName(todo, name);
    if (this.timelineView) this.timelineView.updateTodoName(todo, name);
    if (this.calendarView) this.calendarView.updateTodoName(todo, name);
    this.syncSetupParams();
  },

  onListNameKeyUp(e) {
    const { target: { value: listName }, currentTarget: { dataset: { targetList } } } = e;
    this.updateListName(targetList, listName);
  },

  updateListName(targetList, listName) {
    const targetListName = `${targetList}Name`;
    if (this.listView) this.listView.updateListName(targetList, listName);
    if (this.kanbanView) this.kanbanView.updateListName(targetList, listName);
    if (this.timelineView) this.timelineView.updateListName(targetList, listName);
    this[targetListName] = listName;
    this.syncSetupParams();
  },

  fillDefaultProjectName() {
    if (!this.projectName || this.projectName.length === 0) {
      const { defaultProjectName } = this;
      this.textFieldProjectName.textField.value = defaultProjectName;
      this.updateProjectName(defaultProjectName);
    }
  },

  fillDefaultTodos() {
    ['firstTodo', 'secondTodo', 'thirdTodo'].forEach((todo, index) => {
      const todoName = `${todo}Name`;
      if (!this[todoName] || this[todoName].length === 0) {
        const defaultName = [this.defaultFirstTodoName,
          this.defaultSecondTodoName, this.defaultThirdTodoName][index];
        this.textFieldTodos[index].textField.value = defaultName;
        this.updateTodoName(todo, defaultName, { create: true });
      }
    });
  },

  fillDefaultLists() {
    ['firstList', 'secondList', 'thirdList'].forEach((list, index) => {
      const listName = `${list}Name`;
      if (!this[listName] || this[listName].length === 0) {
        const defaultName = [this.defaultFirstListName,
          this.defaultSecondListName, this.defaultThirdListName][index];
        this[listName] = defaultName;
        this.textFieldLists[index].textField.value = defaultName;
        this.updateListName(list, defaultName);
      }
    });
  },

  fillStepCreateTodoTitle() {
    const createTodoTitle = this.querySelector('tr-account-setup-step[step="create-todos"] .left-panel-title');
    createTodoTitle.innerHTML = createTodoTitle.dataset.templateFirst
      + this.projectName + createTodoTitle.dataset.templateSecond;
  },

  onSelectProjectView(e) {
    const { target: { value: projectView, dataset: { targetView } } } = e;
    const visibileProjectView = this[targetView];
    if (!visibileProjectView) return;

    [this.listView, this.kanbanView, this.timelineView, this.calendarView].forEach((element) => {
      const projectViewElement = element;
      projectViewElement.hidden = !(projectViewElement === visibileProjectView);
    });
    this.projectView = projectView;
    this.syncSetupParams();

    this.querySelectorAll('.project-preview-header-nav-item').forEach((element) => {
      const navItem = element;
      const { dataset: { projectView: itemProjectView } } = navItem;
      if (projectView === itemProjectView) {
        navItem.classList.add('selected');
      } else {
        navItem.classList.remove('selected');
      }
    });
  },

  syncSetupParams() {
    const toUnderScore = key => key.replace(/([A-Z])/g, '_$1').toLowerCase();
    const params = {};
    ['projectName', 'firstTodoName', 'secondTodoName', 'thirdTodoName', 'firstListName', 'secondListName', 'thirdListName', 'projectView'].forEach((key) => {
      params[toUnderScore(key)] = this[key];
    });
    const finishBtn = this.querySelector('[data-action="finish-account-setup"]');
    finishBtn.dataset.params = $.param({
      account_setup: params,
    });
  },
});
